import {
  OAuthProvider,
  signInWithRedirect,
  getRedirectResult,
  signOut as firebaseSignOut,
  onAuthStateChanged,
  type User,
} from 'firebase/auth';
import { auth } from '@/lib/firebase';

const WBD_PROVIDER_ID = 'oidc.wbd';

export async function signInWithWbd(): Promise<void> {
  const provider = new OAuthProvider(WBD_PROVIDER_ID);
  provider.addScope('openid');
  provider.addScope('profile');
  provider.addScope('email');
  await signInWithRedirect(auth, provider);
}

export async function signOutUser(): Promise<void> {
  await firebaseSignOut(auth);
}

export function onAuthChange(callback: (user: User | null) => void): () => void {
  return onAuthStateChanged(auth, callback);
}

export async function consumeRedirectResult(): Promise<void> {
  await getRedirectResult(auth);
}

export async function getIdToken(): Promise<string | null> {
  const user = auth.currentUser;
  if (!user) return null;
  return user.getIdToken();
}
